/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Flex, Text } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import BrandLogo from '../Brand/BrandLogo';
import Mark from '../Mark';
import ListRowSmall from './ListRowSmall';

export default function ExhibitorListRowSmall({
  exhibitor,
  searchTerm,
  to,
  ...rest
}) {
  return (
    <ListRowSmall to={to} {...rest}>
      <Flex gap={2} align="center">
        <BrandLogo brand={exhibitor} size="smaller" />
        <Box>
          <Mark
            text={exhibitor.name}
            term={searchTerm}
            render={(match) => <span sx={{ fontWeight: 'body' }}>{match}</span>}
            Wrapper={LargeText}
            append={(term) => (
              <Text variant="small" sx={{ fontWeight: 'light' }}>
                <Mark
                  text={[
                    exhibitor.countryName,
                    exhibitor.region,
                    exhibitor.city,
                  ]
                    .filter(Boolean)
                    .join(', ')}
                  term={term}
                  render={(match) => (
                    <span sx={{ fontWeight: 'body' }}>{match}</span>
                  )}
                />
              </Text>
            )}
          />
        </Box>
      </Flex>
    </ListRowSmall>
  );
}

function LargeText(props) {
  return <Text variant="large" {...props} />;
}
